// extracted by mini-css-extract-plugin
export default {"container":"ConfirmEmailSigninPage_container__2ELrQ","text":"ConfirmEmailSigninPage_text__7HTEn"};